export default __webpack_public_path__ + "static/media/pink.f23bf742.svg";